import React, { useState, useEffect } from 'react';
import v from '../../utils/Verifiers';
import EtiquetaBarcode from './EtiquetaBarcode';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { getUser, PHP_BACK } from '../../utils/Common';
import axios from 'axios';
import Post from '../../utils/Post';

const HojaEtiquetasBarcodeVer2 = (p) => {
    const [loader, setloader] = useState(false);
    const refrescarEtiquetas = p.refrescarEtiquetas ?? (() => { });
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [imprimir_modo, setimprimir_modo] = useState(false);
    var sizes = { ancho: 0, alto: 0, etiqW: 0, etiqH: 0, anchoInterno: 0, anchoExterno: 0, espVertical: 0 };
    const alto = p.alto ?? 1200;
    sizes.alto = alto;
    sizes.ancho = alto * 0.7727272727272727;
    sizes.etiqH = alto * 0.0454545454545;
    sizes.etiqW = alto * 0.1590909090909091;
    sizes.anchoInterno = alto * 0.0286327845382963;
    sizes.anchoExterno = alto * 0.0250536864710093;
    sizes.espVertical = alto * 0.0429491768074445;
    const hojaStyle = {
        width: `${sizes.ancho}px`,
        height: `${sizes.alto}px`,
        minWidth: `${sizes.ancho}px`,
        paddingTop: `${sizes.espVertical}px`,
        paddingBottom: `${sizes.espVertical}px`,
        paddingLeft: `${sizes.anchoExterno}px`,
        paddingRight: `${sizes.anchoExterno}px`

    }

    const renglonStyle = {
        width: `${sizes.ancho - (sizes.anchoExterno * 2)}px`,
        minWidth: `${sizes.ancho - (sizes.anchoExterno * 2)}px`,
    }

    var etq = [];
    let hoja = [];
    let etiquetas = p.etiquetas ?? [];
    let lenEtiquetas = etiquetas.length;
    for (let i = 0; i < lenEtiquetas; i += 4) {
        let slice = etiquetas.slice(i, i + 4);
        if (hoja.length < 20) hoja.push(slice);
        else {
            etq.push(hoja);
            hoja = [slice];
        }
    }
    etq.push(hoja);

    useEffect(() => {
        setimprimir_modo(false);
    }, [p.etiquetas]);
    const descargarPDF = () => {
        setimprimir_modo(true);
        setloader(true);
        setTimeout(() => {
            try {
                createPDF(0).then(() => setloader(false));
            } catch (error) {
                setloader(false);
            }

        }, 500);
    }

    const createPDF = async (index) => {
        if (etq.length === 0) return;
        setloader(true);

        // Split the document into smaller batches for faster processing
        const batchSize = 5; // Number of pages per batch
        const batches = [];

        for (let i = 0; i < etq.length; i += batchSize) {
            batches.push(etq.slice(i, i + batchSize));
        }

        for (const batch of batches) {
            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [215.9, 279.4],
            });

            for (let i = 0; i < batch.length; i++) {
                const id = `hojaX${i}`;
                const componentRef = document.getElementById(id);
                if (componentRef) {
                    const canvas = await html2canvas(componentRef, { scale: 1.6 });
                    const imgData = canvas.toDataURL('image/png');

                    if (i > 0) {
                        doc.addPage();
                    }
                    doc.addImage(imgData, 'PNG', 0, 0, 215.9, 279.4);
                }
            }

            // Save each batch as a separate file
            doc.save(`ETIQUETAS_BATCH_${batches.indexOf(batch) + 1}.pdf`);
        }

        await marcarComoImpresas();
        setimprimir_modo(false);
        setloader(false);
    }

    const marcarComoImpresas = async () => {
        let plan = null;
        let etk = [];
        let len = p.etiquetas.length;
        if (len === 0) return;
        for (let i = 0; i < len; i++) etk.push(p.etiquetas[i].id);
        let args = { ids: etk, semana: p.etiquetas[0].semana };
        let resp = await v.getDataAPI('/ordenes_trabajo/siembra/etiquetas/imprimir', args, false, false);
        if (!resp.estatus) return;
        v.saveLS('planes_trabajo', resp?.data?.planes ?? []);
    }





    return (
        <>
            <div className='row justify-content-center rounded m-0 p-0' >
                {etq.length > 0 && <div className='w-100 text-center pb-1'>
                    <button className='btn btn-light btn-sm shadow text-bold text-floricents bw-400 round-xxl border border-2 border-warning'
                        onClick={async () => {
                            // window.open(`${PHP_BACK}etiquetas/imprimir?datos=${btoa(JSON.stringify(p.etiquetas))}`, '_blank');
                            //descargarPDF() 
                            const resp = await Post(`etiquetas/imprimir/post`, { datos: etq }, true, false);
                            if (!resp.estatus) {
                                v.setDialog({ visible: true, title: 'Error', content: resp.msj });
                                return;
                            }
                            const url = `${PHP_BACK}etiquetas/imprimir/get/${resp.data}?token=${getUser().token}`;
                            window.open(url, '_blank');
                            setTimeout(() => {

                                refrescarEtiquetas();
                            }, etq.length * 800);
                        }}>Descargar {etq.length} hoja(s)</button>
                </div>}
                {v.divisorHTML()}
                <div className='bw-1300 round-m bg-white5 blur-xxl shadow-multi mt-2' style={{ overflow: 'auto', height: '65vh' }}>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>


                        {etq.map((hoja, i) => {
                            return (
                                <React.Fragment key={v.keyGen()}>
                                    {v.divisorHTML(null, 30)}

                                    <div className='col-lg-12 m-0 border bg-white pb-1 shadow-multi'
                                        id={"hojaX" + i}
                                        style={hojaStyle}>

                                        <div className='row justify-content-center p-0 m-0 '>
                                            {
                                                hoja.map((renglon, j) => {
                                                    return (
                                                        <div key={v.keyGen()} className='row justify-content-bewtween  m-0 p-0'
                                                            style={renglonStyle}>
                                                            {
                                                                renglon.map((etq, j) => {
                                                                    return (<React.Fragment key={v.keyGen()}>
                                                                        <EtiquetaBarcode sizes={{ width: sizes.etiqW, height: sizes.etiqH }}
                                                                            index={j}
                                                                            interno={sizes.anchoInterno}
                                                                            externo={sizes.anchoExterno}
                                                                            alto_etiqueta={sizes.etiqH}
                                                                            ancho_etiqueta={sizes.etiqW}
                                                                            data={etq}
                                                                            imprimir={imprimir_modo}
                                                                        />
                                                                    </React.Fragment>)
                                                                })
                                                            }
                                                        </div>

                                                    )


                                                })
                                            }

                                        </div>
                                    </div>
                                </React.Fragment>

                            )
                        })}
                    </div>
                </div>
            </div>
            {loader && ldr}
        </>

    );
}

export default HojaEtiquetasBarcodeVer2;